import { Star } from "lucide-react";
import React from "react";

function StarReviewEditable({
  rating,
  size = 20,
  padding = "4px",
  onStarClick = () => {},
}) {
  const totalStars = 5;
  const filledStars = Math.floor(rating);

  return (
    <div className="d-flex align-items-center gap-3">
      {Array.from({ length: totalStars }).map((_, index) => (
        <div key={index} className="star-wrapper">
          <span
            style={{ width: size, height: size, padding }}
            className={`star star-editable ${
              index < filledStars ? "filled" : "empty"
            }`}
            onClick={() => onStarClick(index + 1)}
          >
            <Star fill="white" stroke="white" />
          </span>
        </div>
      ))}
    </div>
  );
}

export default StarReviewEditable;
